import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToId } from "./SmoothScroll";
import { waLink } from "@/data/content";

const LINKS = [
  { id: "aplicativos", label: "Aplicativos" },
  { id: "servicos", label: "Serviços" },
  { id: "metodo", label: "Método" },
  { id: "contato", label: "Contato" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "bg-[#070D1F]/80 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <button data-testid="nav-logo" onClick={() => go("top")} className="flex items-center gap-3">
          <img src="/assets/mark-t.png" alt="FMACIEL" className="h-10 w-auto logo-glow" />
          <span className="leading-none text-left">
            <span className="font-display text-xl font-extrabold tracking-wider steel-text block">FMACIEL</span>
            <span className="font-mono text-[10px] tracking-[0.2em] text-[var(--steel-2)]">CONSULTORIA E PROJETOS</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="group relative text-sm text-[var(--steel-2)] hover:text-white transition-colors"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[var(--cyan)] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
          <a
            data-testid="nav-whatsapp-cta"
            href={waLink("Olá! Gostaria de solicitar um orçamento com a FMACIEL.")}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 rounded-full bg-[var(--blue)] px-5 py-2.5 text-sm font-medium text-white hover:bg-[#4a7dff] transition-colors"
          >
            Orçamento <ArrowUpRight size={16} />
          </a>
        </nav>

        <button data-testid="nav-mobile-toggle" aria-label="Menu" onClick={() => setOpen(!open)} className="md:hidden p-2 text-white">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden overflow-hidden bg-[#070D1F]/95 backdrop-blur-xl border-b border-white/10"
          >
            <div className="px-5 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <button key={l.id} data-testid={`nav-mobile-link-${l.id}`} onClick={() => go(l.id)} className="text-left font-display text-3xl font-bold uppercase text-white">
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
